
<template>
  <div>
    <vs-tabs alignment="fixed" color="rgb(32, 201, 192)">
      <vs-tab label="รายการที่ถูกยืม">
        <borrow-table
          apiname="borrow/frombranch"
          idname="borrowId"
          :view="view"
          :viewform="viewform"
          :init="init"
          :filednum="0"
          labelname="รายการที่ถูกยืม"
          :borrowtype="1"
          tabletype="n"
        ></borrow-table>
      </vs-tab>
      <vs-tab label="รายการขอยืม">
        <borrow-table
          apiname="borrow/tobranch"
          idname="borrowId"
          :view="view"
          :viewform="viewform"
          :init="init"
          :filednum="0"
          labelname="รายการขอยืม"
          :borrowtype="2"
          tabletype="n"
        ></borrow-table>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import BorrowTable from "./Components/BorrowTable.vue";
export default {
  data() {
    return {
      view: [
        "borrowId",
        "approve",
        "fromBranch",
        "toBranch",
        "qty",
        "startDate",
        "endDate",
        "productItemId",
        "borrowNumber",
        "updateBy",
        "updateDateTime"
      ],
      viewform: [
        // { name: "name", label: "ชื่อลูกค้า", form: "text" },
        // { name: "address", label: "ที่อยู่", form: "textarea" },
        // { name: "phone", label: "เบอรโทร", form: "text" },
        // { name: "state", label: "สถานะ", form: "switch" }
      ],
      init: {
        borrowId: "",
        approve: "",
        fromBranch: "",
        toBranch: "",
        qty: 0,
        startDate: null,
        endDate: null,
        productItemId: "",
        borrowNumber: "",
        updateBy: "",
        updateDateTime: null
      }
    };
  },
  components: {
    BorrowTable
  }
};
</script>
<style>
.vs-tabs--btn {
  font-weight: bold;
}
</style>
